import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { Button, Paper, Typography } from '@mui/material';

import { BackButton, PageTitle, Radio, RadioLabel } from '../../../../components/common';
import ButtonContainer from '../../../../components/ButtonContainer';

import {
  StyledTreatmentCategory,
  StyledTreatmentCategoryImage,
  StyledRadioOptionContainer,
  StyledVerticalContent,
} from './SelectTreatmentCategory.styled';

const SelectTreatmentCategory = ({
  backButtonLink,
  nextButtonLink,
  treatmentCategory,
  setTreatmentCategory,
  pageTitleId,
  pageDescriptionId,
  treatmentCategoryConfig,
}) => {
  const history = useHistory();

  const validatedTreatmentCategoryConfig = Array.isArray(treatmentCategoryConfig)
    ? treatmentCategoryConfig
    : [];

  return (
    <>
      <BackButton to={backButtonLink}>
        <Typography variant="h3">
          <FormattedMessage id="common.button.back" />
        </Typography>
      </BackButton>

      {pageTitleId && (
        <PageTitle>
          <Typography variant="h1">
            <FormattedMessage id={pageTitleId} />
          </Typography>
        </PageTitle>
      )}

      <StyledVerticalContent>
        {pageDescriptionId && (
          <Typography variant="p" color="professional_blue">
            <FormattedMessage id={pageDescriptionId} />
          </Typography>
        )}

        {validatedTreatmentCategoryConfig.map((item) => {
          const { label, value, image } = item || {};
          return (
            <Paper key={value}>
              <StyledTreatmentCategory>
                <StyledRadioOptionContainer onClick={() => setTreatmentCategory(value)}>
                  <Radio
                    name="treatment_category"
                    value={value}
                    checked={value === treatmentCategory}
                    onChange={(e) => {
                      e.stopPropagation();
                      setTreatmentCategory(value);
                    }}
                  />

                  <StyledTreatmentCategoryImage src={image} alt={value} />
                  <RadioLabel>
                    <Typography variant="p" color="professional_blue">
                      <FormattedMessage id={label} />
                    </Typography>
                  </RadioLabel>
                </StyledRadioOptionContainer>
              </StyledTreatmentCategory>
            </Paper>
          );
        })}
      </StyledVerticalContent>

      <ButtonContainer>
        <Button
          disabled={!treatmentCategory}
          onClick={() => history.push(nextButtonLink)}
          data-testid="btn_treatment_cat_next"
        >
          <Typography variant="buttons">
            <FormattedMessage id="common.button.next" />
          </Typography>
        </Button>
      </ButtonContainer>
    </>
  );
};

export default SelectTreatmentCategory;
